import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Layout from "../Layout";
import { BaseUrl } from "../BaseUrl";

const DetailedFacility = ({ setStep, formData = {}, setFormData }) => {
  const [facilityTypes, setFacilityTypes] = useState([]);
  const [facilitySubTypes, setFacilitySubTypes] = useState([]);
  const [operationStatuses, setOperationStatuses] = useState([]);
  const [IPDBedsWithoutOxygen, setIPDBedsWithoutOxygen] = useState(0);
  const [DentalChairs, setDentalChairs] = useState(0);
  const [timings, setTimings] = useState({
    Mon: {
      is24Hrs: false,
      shift1From: "",
      shift1To: "",
      shift2From: "",
      shift2To: "",
    },
    Tue: {
      is24Hrs: false,
      shift1From: "",
      shift1To: "",
      shift2From: "",
      shift2To: "",
    },
    Wed: {
      is24Hrs: false,
      shift1From: "",
      shift1To: "",
      shift2From: "",
      shift2To: "",
    },
    Thu: {
      is24Hrs: false,
      shift1From: "",
      shift1To: "",
      shift2From: "",
      shift2To: "",
    },
    Fri: {
      is24Hrs: false,
      shift1From: "",
      shift1To: "",
      shift2From: "",
      shift2To: "",
    },
    Sat: {
      is24Hrs: false,
      shift1From: "",
      shift1To: "",
      shift2From: "",
      shift2To: "",
    },
    Sun: {
      is24Hrs: false,
      shift1From: "",
      shift1To: "",
      shift2From: "",
      shift2To: "",
    },
  });
  const [abdmSoftware, setAbdmSoftware] = useState([""]);
  const [abdmOther, setAbdmOther] = useState("");

  const facilityInformation = formData.facilityInformation || {
    ownershipCode: "",
    ownershipSubTypeCode: "",
    ownershipSubTypeCode2: "",
    systemOfMedicineCode: [], // Changed to array to support multiple selections
    typeOfServiceCode: "",
    offersSpecializations: "", // Y/N field for specializations
    specializations: [], // New field for specializations
    facilityTypeCode: "",
    facilitySubType: "",
    facilityOperationalStatus: "",
    facilityUploads: { facilityBuildingPhoto: { name: "", value: "" } },
    facilityAddressProof: [
      { addressProofType: "", addressProofAttachment: { name: "", value: "" } },
    ],
    timingsOfFacility: [],
    abdmCompliantSoftware: [{ existingSoftwares: [""], anyOther: "" }],
    aboutUs: "",

    // Newly added fields
    countIPDBedsWithoutOxygen: "",
    countIPDBedsWithOxygen: "",
    countICUBedsWithVentilators: "",
    countICUBedsWithoutVentilators: "",
    countHDUBedsWithFunctionalVentilators: "",
    countHDUBedsWithVentilators: "",
    countHDUBedsWithoutVentilators: "",
    totalNumberOfVentilators: "",
    countDayCareBedsWithoutOxygen: "",
    countDayCareBedsWithOxygen: "",
    totalNumberOfBeds: "",
    countDentalChairs: "",
  };

  console.log("facilityInformation", facilityInformation);

  const ownershipOptions = [
    { code: "G", value: "Government" },
    { code: "P", value: "Private" },
    { code: "PP", value: "Public Private Partnership" },
  ];

  const medicineOptions = [
    { code: "UN", value: "Unani" },
    { code: "M", value: "Modern Medicine(Allopathy)" },
    { code: "YN", value: "Yoga and Naturopathy" },
    { code: "A", value: "Ayurveda" },
    { code: "SD", value: "Siddha" },
    { code: "H", value: "Homeopathy" },
    { code: "P", value: "Physiotherapy" },
    { code: "SR", value: "Sowa-Rigpa" },
    { code: "D", value: "Dentistry" },
  ];

  const specializationOptions = [
    "Anaesthesia",
    "Cardiothoracic and vascular surgery",
    "Dialysis",
    "Family Medicine",
    "Genetics",
    "Immunology",
    "Nephrology",
    "Aviation medicine",
    "Cath lab",
    "Emergency medicine",
    "Genitourinary Surgery",
    "Interventional cardiology",
    "Neurology",
    "Burns, Plastic and reconstructive Surgery",
    "Critical care",
    "Endocrinology",
    "General Medicine",
    "Geriatrics",
    "Medicolegal / Forensic Medicine",
    "Neuroradiology",
    "Cardiology",
    "Dermatology and Venerology (Skin & VD) RTI/STI",
    "ENT",
    "General Surgery",
    "Hepatology",
    "Neurology",
  ];

  useEffect(() => {
    fetchOperationStatuses();
  }, []);

  useEffect(() => {
    if (
      facilityInformation.ownershipCode &&
      facilityInformation.systemOfMedicineCode &&
      facilityInformation.systemOfMedicineCode.length > 0
    ) {
      fetchFacilityTypes();
    }
  }, [
    facilityInformation.ownershipCode,
    facilityInformation.systemOfMedicineCode,
  ]);

  useEffect(() => {
    if (facilityInformation.facilityTypeCode) {
      fetchFacilitySubTypes();
    }
  }, [facilityInformation.facilityTypeCode]);

  const fetchOperationStatuses = async () => {
    try {
      const response = await fetch(
        `${BaseUrl}/doctor/hfr/get-master-data?type=FAC-STATUS`
      );
      const data = await response.json();
      if (data.success) {
        setOperationStatuses(data.data.data);
      }
    } catch (error) {
      console.error("Error fetching operation statuses:", error);
    }
  };

  const fetchFacilityTypes = async () => {
    try {
      // If multiple systems of medicine are selected, we need to handle this appropriately
      // For now, we'll use the first selected system or send all selected systems
      const systemCode = Array.isArray(facilityInformation.systemOfMedicineCode)
        ? facilityInformation.systemOfMedicineCode[0]
        : facilityInformation.systemOfMedicineCode;

      const response = await fetch(`${BaseUrl}/doctor/hfr/get-facility-type`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          ownershipCode: facilityInformation.ownershipCode,
          systemOfMedicineCode: systemCode,
        }),
      });
      const data = await response.json();
      if (data.success) {
        setFacilityTypes(data.data.data);
        setFormData((prev) => ({
          ...prev,
          facilityInformation: {
            ...prev.facilityInformation,
            facilityTypeCode: "",
            facilitySubType: "",
          },
        }));
        setFacilitySubTypes([]);
      }
    } catch (error) {
      console.error("Error fetching facility types:", error);
    }
  };

  const fetchFacilitySubTypes = async () => {
    try {
      const response = await fetch(
        `${BaseUrl}/doctor/hfr/get-facility-subtype?facilityTypeCode=${facilityInformation.facilityTypeCode}`,
        { method: "GET" }
      );
      const data = await response.json();
      console.log("Facility SubTypes response:", data);
      if (data.success) {
        // Handle both API response structures
        const subtypes = data.data?.data || data.data || [];
        setFacilitySubTypes(subtypes);
        setFormData((prev) => ({
          ...prev,
          facilityInformation: {
            ...prev.facilityInformation,
            facilitySubType: "",
          },
        }));
      }
    } catch (error) {
      console.error("Error fetching facility sub types:", error);
    }
  };

  const toggleService = (service) => {
    setFormData((prev) => {
      const currentServices = (
        prev.facilityInformation?.typeOfServiceCode || ""
      )
        .split(",")
        .filter((s) => s);
      return {
        ...prev,
        facilityInformation: {
          ...prev.facilityInformation,
          typeOfServiceCode: currentServices.includes(service)
            ? currentServices.filter((s) => s !== service).join(",")
            : [...currentServices, service].join(","),
        },
      };
    });
  };

  const handleSpecializationChange = (specialization) => {
    setFormData((prev) => {
      const currentSpecializations =
        prev.facilityInformation?.specializations || [];
      if (currentSpecializations.includes(specialization)) {
        // Remove if already selected
        return {
          ...prev,
          facilityInformation: {
            ...prev.facilityInformation,
            specializations: currentSpecializations.filter(
              (spec) => spec !== specialization
            ),
          },
        };
      } else {
        // Add if not selected
        return {
          ...prev,
          facilityInformation: {
            ...prev.facilityInformation,
            specializations: [...currentSpecializations, specialization],
          },
        };
      }
    });
  };

  const handleTimingChange = (day, field, value) => {
    setTimings((prev) => ({
      ...prev,
      [day]: { ...prev[day], [field]: value },
    }));
  };

  const formatTimeTo12Hour = (time) => {
    if (!time) return "";
    const [hours, minutes] = time.split(":");
    let hour = parseInt(hours, 10);
    const period = hour >= 12 ? "PM" : "AM";
    hour = hour % 12 || 12; // Convert 0 to 12 for 12 AM/PM
    return `${hour}:${minutes} ${period}`;
  };

  const formatTimings = () => {
    const formatted = [];
    Object.keys(timings).forEach((day) => {
      const dayTiming = timings[day];
      if (dayTiming.is24Hrs) {
        formatted.push({
          workingDays: day.toUpperCase(),
          openingHours: "24*7",
        });
      } else {
        if (dayTiming.shift1From && dayTiming.shift1To) {
          formatted.push({
            workingDays: day.toUpperCase(),
            openingHours: `${formatTimeTo12Hour(dayTiming.shift1From)} - ${formatTimeTo12Hour(dayTiming.shift1To)}`,
          });
        }
        if (dayTiming.shift2From && dayTiming.shift2To) {
          formatted.push({
            workingDays: day.toUpperCase(),
            openingHours: `${formatTimeTo12Hour(dayTiming.shift2From)} - ${formatTimeTo12Hour(dayTiming.shift2To)}`,
          });
        }
      }
    });
    return formatted;
  };

  const handleAbdmSoftwareChange = (index, value) => {
    const newSoftware = [...abdmSoftware];
    newSoftware[index] = value;
    setAbdmSoftware(newSoftware);
  };

  const handleSystemOfMedicine = (medicineCode) => {
    setFormData((prev) => {
      const currentMedicines =
        prev.facilityInformation?.systemOfMedicineCode || [];
      if (currentMedicines.includes(medicineCode)) {
        // Remove if already selected
        return {
          ...prev,
          facilityInformation: {
            ...prev.facilityInformation,
            systemOfMedicineCode: currentMedicines.filter(
              (code) => code !== medicineCode
            ),
          },
        };
      } else {
        // Add if not selected
        return {
          ...prev,
          facilityInformation: {
            ...prev.facilityInformation,
            systemOfMedicineCode: [...currentMedicines, medicineCode],
          },
        };
      }
    });
  };

  const addAbdmSoftware = () => {
    setAbdmSoftware([...abdmSoftware, ""]);
  };

  const handleSaveDraft = () => {
    const { ownershipCode, ownershipSubTypeCode, ownershipSubTypeCode2 } =
      formData.facilityInformation;
    if (ownershipCode === "G" && !ownershipSubTypeCode) {
      alert("Ownership Sub-Type is required for Government facilities.");
      return;
    }
    if (ownershipSubTypeCode === "S" && !ownershipSubTypeCode2) {
      alert("Specifying Profit is required when Sub-Type is Profit.");
      return;
    }
    // Validate that at least one system of medicine is selected
    if (
      !facilityInformation.systemOfMedicineCode ||
      facilityInformation.systemOfMedicineCode.length === 0
    ) {
      alert("Please select at least one system of medicine before proceeding.");
      return;
    }

    // Validate service type only if it's mandatory for the selected facility type
    if (
      isServiceMandatory() &&
      (!facilityInformation.typeOfServiceCode ||
        facilityInformation.typeOfServiceCode.trim() === "")
    ) {
      alert("Please select at least one type of service before proceeding.");
      return;
    }

    // Validate specializations if user selected "Y" for offers specializations
    if (
      facilityInformation.offersSpecializations === "Y" &&
      (!facilityInformation.specializations ||
        facilityInformation.specializations.length === 0)
    ) {
      alert(
        "Please select at least one specialization since you indicated the facility offers specializations."
      );
      return;
    }

    // Validate that specializations question is answered
    if (!facilityInformation.offersSpecializations) {
      alert(
        "Please indicate whether the facility offers any specializations or services for the selected system of medicine."
      );
      return;
    }

    setFormData((prev) => ({
      ...prev,
      facilityInformation: {
        ...prev.facilityInformation,
        timingsOfFacility: formatTimings(),
        abdmCompliantSoftware: [
          {
            existingSoftwares: abdmSoftware.filter((s) => s),
            anyOther: abdmOther,
          },
        ],
      },
    }));
    setStep(3);
  };

  const addAddressProof = () => {
    if ((facilityInformation.facilityAddressProof || []).length < 3) {
      setFormData((prev) => ({
        ...prev,
        facilityInformation: {
          ...prev.facilityInformation,
          facilityAddressProof: [
            ...(prev.facilityInformation?.facilityAddressProof || []),
            {
              addressProofType: "",
              addressProofAttachment: { name: "", value: "" },
            },
          ],
        },
      }));
    }
  };

  const isServiceMandatory = () => {
    // Service type is not mandatory for these facility types
    const nonMandatoryFacilityTypes = [
      "Pharmacy",
      "Blood bank",
      "Diagnostic Lab",
      "Imaging Center",
      "Cath lab",
      "Dialysis Center",
    ];

    // Check if current facility type is in the non-mandatory list
    const currentFacilityType = (facilityTypes || []).find(
      (type) => type.code === facilityInformation.facilityTypeCode
    );

    if (
      currentFacilityType &&
      nonMandatoryFacilityTypes.includes(currentFacilityType.value)
    ) {
      return false;
    }

    return true;
  };

  const updateAddressProof = (index, file) => {
    if (file && file.size > 5 * 1024 * 1024) {
      alert("File size must be less than 5MB");
      return;
    }
    const newProofs = [...facilityInformation.facilityAddressProof];
    newProofs[index] = {
      ...newProofs[index],
      addressProofAttachment: { name: file ? file.name : "", value: "" },
    };
    setFormData((prev) => ({
      ...prev,
      facilityInformation: {
        ...prev.facilityInformation,
        facilityAddressProof: newProofs,
      },
    }));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Only allow numeric values with max 2 chars (default rule)
    if (!/^\d{0,4}$/.test(value)) return;

    setFormData((prev) => {
      const updated = {
        ...prev,
        facilityInformation: {
          ...prev.facilityInformation,
          [name]: value,
        },
      };

      // Auto-calc totalNumberOfVentilators
      const ventilatorTotal =
        parseInt(updated.facilityInformation.countICUBedsWithVentilators || 0) +
        parseInt(
          updated.facilityInformation.countHDUBedsWithFunctionalVentilators || 0
        ) +
        parseInt(updated.facilityInformation.countHDUBedsWithVentilators || 0);

      updated.facilityInformation.totalNumberOfVentilators =
        ventilatorTotal.toString();

      // Auto-calc totalNumberOfBeds
      const bedTotal =
        parseInt(updated.facilityInformation.countIPDBedsWithoutOxygen || 0) +
        parseInt(updated.facilityInformation.countIPDBedsWithOxygen || 0) +
        parseInt(
          updated.facilityInformation.countICUBedsWithoutVentilators || 0
        ) +
        parseInt(
          updated.facilityInformation.countHDUBedsWithoutVentilators || 0
        ) +
        parseInt(
          updated.facilityInformation.countDayCareBedsWithoutOxygen || 0
        ) +
        parseInt(updated.facilityInformation.countDayCareBedsWithOxygen || 0);

      updated.facilityInformation.totalNumberOfBeds = bedTotal.toString();

      return updated;
    });
  };

  const days = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];

  const isFunctional =
    facilityInformation.facilityOperationalStatus === "F";

  return (
    <div className='min-h-screen bg-white'>
      <Layout>
        <div className='mb-6 flex justify-center'>
          <div className='flex items-center gap-4 text-sm font-semibold'>
            <div className='flex h-6 w-6 items-center justify-center rounded-full bg-blue-500 text-white'>
              1
            </div>
            <span className='text-blue-500'>Facility Registration Form</span>
            <div className='h-1 w-8 bg-blue-600' />
            <div className='flex h-6 w-6 items-center justify-center rounded-full bg-blue-500 text-white'>
              2
            </div>
            <span className='text-blue-500'>Detailed Facility Information</span>
            <div className='h-1 w-8 bg-gray-300' />
            <div className='flex h-6 w-6 items-center justify-center rounded-full bg-gray-300 text-gray-600'>
              3
            </div>
            <span className='text-gray-500'>Preview Profile</span>
          </div>
        </div>

        <div className='mb-6 w-fit rounded-md bg-[#009FE3] px-4 py-2 text-lg font-semibold text-white'>
          Detailed Facility Information
        </div>

        <div className='mb-6 grid grid-cols-1 gap-6 md:grid-cols-3'>
          <div>
            <label className='mb-1 block font-medium'>
              Facility Ownership*
            </label>
            <div className='flex items-center gap-6 text-sm'>
              {ownershipOptions.map((opt) => (
                <label key={opt.code} className='flex items-center gap-1'>
                  <input
                    type='radio'
                    name='ownership'
                    value={opt.code}
                    checked={facilityInformation.ownershipCode === opt.code}
                    onChange={() =>
                      setFormData((prev) => ({
                        ...prev,
                        facilityInformation: {
                          ...prev.facilityInformation,
                          ownershipCode: opt.code,
                        },
                      }))
                    }
                    className='mr-1'
                  />
                  {opt.value}
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              <span className='flex flex-row items-center gap-1'>
                Facility Ownership Subtype
                {facilityInformation.ownershipCode === "G" && (
                  <p className='text-red-500'>*</p>
                )}
              </span>
            </label>

            <div className='flex flex-wrap items-center gap-6 text-sm'>
              {["Profit", "Not for Profit"].map((type) => (
                <label key={type} className='flex items-center gap-1'>
                  <input
                    type='radio'
                    name='ownershipSubtype'
                    value={type === "Profit" ? "S" : "N"}
                    checked={
                      facilityInformation.ownershipSubTypeCode ===
                      (type === "Profit" ? "S" : "N")
                    }
                    onChange={() =>
                      setFormData((prev) => ({
                        ...prev,
                        facilityInformation: {
                          ...prev.facilityInformation,
                          ownershipSubTypeCode: type === "Profit" ? "S" : "N",
                        },
                      }))
                    }
                    className='mr-1'
                  />
                  {type}
                </label>
              ))}
            </div>
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              <span className='flex flex-row items-center gap-1'>
                Profit
                {facilityInformation.ownershipSubTypeCode === "S" && (
                  <p className='text-red-500'>*</p>
                )}
              </span>
            </label>

            <select
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm'
              value={facilityInformation.ownershipSubTypeCode2}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  facilityInformation: {
                    ...prev.facilityInformation,
                    ownershipSubTypeCode2: e.target.value,
                  },
                }))
              }
            >
              <option value=''>select</option>
              <option value='PP01'>Yes</option>
              <option value='PP02'>No</option>
            </select>
          </div>
        </div>

        <div className='mb-6'>
          <label className='mb-2 block font-medium'>System of Medicine*</label>
          <div className='grid grid-cols-2 gap-4 rounded-lg border border-gray-300 p-4 md:grid-cols-3'>
            {medicineOptions.map((opt) => (
              <label
                key={opt.code}
                className='flex cursor-pointer items-center gap-2'
              >
                <input
                  type='checkbox'
                  checked={
                    facilityInformation.systemOfMedicineCode?.includes(
                      opt.code
                    ) || false
                  }
                  onChange={() => handleSystemOfMedicine(opt.code)}
                  className='h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500'
                />
                <span className='text-sm text-gray-700'>{opt.value}</span>
              </label>
            ))}
          </div>
          {facilityInformation.systemOfMedicineCode &&
            facilityInformation.systemOfMedicineCode.length > 0 && (
              <div className='mt-2 text-sm text-blue-600'>
                Selected: {facilityInformation.systemOfMedicineCode.length}{" "}
                system(s) of medicine
              </div>
            )}
          {(!facilityInformation.systemOfMedicineCode ||
            facilityInformation.systemOfMedicineCode.length === 0) && (
            <div className='mt-2 text-sm text-red-500'>
              Please select at least one system of medicine
            </div>
          )}
        </div>

        <div className='mb-6 grid grid-cols-1 gap-6 md:grid-cols-3'>
          <div>
            <label className='mb-1 block font-medium'>Facility Type</label>
            <select
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm'
              value={facilityInformation.facilityTypeCode}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  facilityInformation: {
                    ...prev.facilityInformation,
                    facilityTypeCode: e.target.value,
                  },
                }))
              }
            >
              <option value=''>select</option>
              {(facilityTypes || []).map((opt) => (
                <option key={opt.code} value={opt.code}>
                  {opt.value}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className='mb-1 block font-medium'>Facility Sub Type</label>
            <select
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm'
              value={facilityInformation.facilitySubType}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  facilityInformation: {
                    ...prev.facilityInformation,
                    facilitySubType: e.target.value,
                  },
                }))
              }
            >
              <option value=''>select</option>
              {(facilitySubTypes || []).map((opt) => (
                <option key={opt.code} value={opt.code}>
                  {opt.value}
                </option>
              ))}
            </select>
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              Facility Operation Status
            </label>
            <select
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm'
              value={facilityInformation.facilityOperationalStatus}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  facilityInformation: {
                    ...prev.facilityInformation,
                    facilityOperationalStatus: e.target.value,
                  },
                }))
              }
            >
              <option value=''>select</option>
              {(operationStatuses || []).map((opt) => (
                <option key={opt.code} value={opt.code}>
                  {opt.value}
                </option>
              ))}
            </select>
          </div>
        </div>

        <div className='mb-6'>
          <label className='mb-2 block font-medium'>Types of Service</label>
          <div className='flex gap-4'>
            {["OPD", "IPD", "Daycare"].map((type) => (
              <button
                key={type}
                onClick={() => toggleService(type)}
                className={`rounded border px-6 py-2 text-sm transition-colors duration-200 ${
                  (facilityInformation.typeOfServiceCode || "").includes(type)
                    ? "border-[#009FE3] bg-[#009FE3] text-white hover:bg-[#0078B3]"
                    : "border-gray-300 bg-white text-gray-700 hover:border-gray-400 hover:bg-gray-50"
                }`}
              >
                {type}
              </button>
            ))}
          </div>
        </div>

        <div className='mb-6'>
          <label className='mb-2 block font-medium'>
            Does the facility offer any specializations or services for above
            selected system of medicine?*
          </label>
          <div className='flex items-center gap-6 text-sm'>
            {[
              { code: "Y", value: "Yes" },
              { code: "N", value: "No" },
            ].map((opt) => (
              <label key={opt.code} className='flex items-center gap-1'>
                <input
                  type='radio'
                  name='offersSpecializations'
                  value={opt.code}
                  checked={
                    facilityInformation.offersSpecializations === opt.code
                  }
                  onChange={() =>
                    setFormData((prev) => ({
                      ...prev,
                      facilityInformation: {
                        ...prev.facilityInformation,
                        offersSpecializations: opt.code,
                        // Clear specializations if "No" is selected
                        specializations:
                          opt.code === "N"
                            ? []
                            : prev.facilityInformation?.specializations || [],
                      },
                    }))
                  }
                  className='mr-1'
                />
                {opt.value}
              </label>
            ))}
          </div>
        </div>

        {facilityInformation.offersSpecializations === "Y" && (
          <div className='mb-6'>
            <label className='mb-2 block font-medium'>
              Services / Specializations <span className='text-red-500'>*</span>
            </label>
            <div className='grid grid-cols-4 gap-4 rounded-lg border border-gray-300 p-4'>
              {specializationOptions.map((specialization, index) => (
                <label
                  key={index}
                  className='flex cursor-pointer items-center gap-2'
                >
                  <input
                    type='checkbox'
                    checked={
                      facilityInformation.specializations?.includes(
                        specialization
                      ) || false
                    }
                    onChange={() => handleSpecializationChange(specialization)}
                    className='h-4 w-4 rounded border-gray-300 text-blue-600 focus:ring-blue-500'
                  />
                  <span className='text-sm text-gray-700'>
                    {specialization}
                  </span>
                </label>
              ))}
            </div>
            {facilityInformation.specializations &&
              facilityInformation.specializations.length > 0 && (
                <div className='mt-2 text-sm text-blue-600'>
                  Selected: {facilityInformation.specializations.length}{" "}
                  specialization(s)
                </div>
              )}
            {facilityInformation.offersSpecializations === "Y" &&
              (!facilityInformation.specializations ||
                facilityInformation.specializations.length === 0) && (
                <div className='mt-2 text-sm text-red-500'>
                  Please select at least one specialization
                </div>
              )}
          </div>
        )}

        {/* New Fields Section */}
        <div className='mb-6 w-fit rounded-md bg-[#009FE3] px-4 py-2 text-lg font-semibold text-white'>
          Medical Infrastructure
        </div>
        <div className='mb-6 grid grid-cols-1 gap-6 md:grid-cols-3'>
          {/* Row 1 */}
          <div>
            <label className='mb-1 block font-medium'>
              IPD Beds Without Oxygen
            </label>
            <input
              type='text'
              name='countIPDBedsWithoutOxygen'
              value={facilityInformation.countIPDBedsWithoutOxygen}
              onChange={handleChange}
              maxLength={2}
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              IPD Beds With Oxygen
            </label>
            <input
              type='text'
              name='countIPDBedsWithOxygen'
              value={facilityInformation.countIPDBedsWithOxygen}
              onChange={handleChange}
              maxLength={2}
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              ICU Beds With Ventilators
            </label>
            <input
              type='text'
              name='countICUBedsWithVentilators'
              value={facilityInformation.countICUBedsWithVentilators}
              onChange={handleChange}
              maxLength={2}
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
          </div>

          {/* Row 2 */}
          <div>
            <label className='mb-1 block font-medium'>
              ICU Beds Without Ventilators
            </label>
            <input
              type='text'
              name='countICUBedsWithoutVentilators'
              value={facilityInformation.countICUBedsWithoutVentilators}
              onChange={handleChange}
              maxLength={2}
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              HDU Beds With Functional Ventilators
            </label>
            <input
              type='text'
              name='countHDUBedsWithFunctionalVentilators'
              value={facilityInformation.countHDUBedsWithFunctionalVentilators}
              onChange={handleChange}
              maxLength={2}
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              HDU Beds With Ventilators
            </label>
            <input
              type='text'
              name='countHDUBedsWithVentilators'
              value={facilityInformation.countHDUBedsWithVentilators}
              onChange={handleChange}
              maxLength={2}
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
          </div>

          {/* Row 3 */}
          <div>
            <label className='mb-1 block font-medium'>
              HDU Beds Without Ventilators
            </label>
            <input
              type='text'
              name='countHDUBedsWithoutVentilators'
              value={facilityInformation.countHDUBedsWithoutVentilators}
              onChange={handleChange}
              maxLength={2}
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              Day Care Beds Without Oxygen
            </label>
            <input
              type='text'
              name='countDayCareBedsWithoutOxygen'
              value={facilityInformation.countDayCareBedsWithoutOxygen}
              onChange={handleChange}
              maxLength={2}
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              Day Care Beds With Oxygen
            </label>
            <input
              type='text'
              name='countDayCareBedsWithOxygen'
              value={facilityInformation.countDayCareBedsWithOxygen}
              onChange={handleChange}
              maxLength={2}
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
          </div>

          {/* Row 4 */}
          <div>
            <label className='mb-1 block font-medium'>Dental Chairs</label>
            <input
              type='text'
              name='countDentalChairs'
              value={facilityInformation.countDentalChairs}
              onChange={handleChange}
              maxLength={2}
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400'
            />
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              Total Number of Ventilators
            </label>
            <input
              type='text'
              name='totalNumberOfVentilators'
              value={facilityInformation.totalNumberOfVentilators}
              readOnly
              className='w-full cursor-not-allowed rounded border border-gray-300 bg-gray-100 px-3 py-2 text-sm'
            />
          </div>

          <div>
            <label className='mb-1 block font-medium'>
              Total Number of Beds
            </label>
            <input
              type='text'
              name='totalNumberOfBeds'
              value={facilityInformation.totalNumberOfBeds}
              readOnly
              className='w-full cursor-not-allowed rounded border border-gray-300 bg-gray-100 px-3 py-2 text-sm'
            />
          </div>
        </div>

        <div className='mb-6'>
          <div className='mb-6 w-fit rounded-md bg-[#009FE3] px-4 py-2 text-lg font-semibold text-white'>
            Additional Facility Details
          </div>
          <div className='mb-4 overflow-x-auto rounded-lg border'>
            <table className='w-full text-sm text-gray-800'>
              <thead className='bg-gray-100'>
                <tr>
                  <th className='px-3 py-2'>Day</th>
                  <th className='px-3 py-2'>24 Hrs</th>
                  <th className='px-3 py-2'>Shift 1 (From)</th>
                  <th className='px-3 py-2'>Shift 1 (To)</th>
                  <th className='px-3 py-2'>Shift 2 (From)</th>
                  <th className='px-3 py-2'>Shift 2 (To)</th>
                </tr>
              </thead>
              <tbody>
                {days.map((day) => (
                  <tr key={day} className='text-center'>
                    <td className='px-3 py-2'>
                      <button
                        type='button'
                        className={`w-full rounded py-1 text-sm font-semibold ${
                          day === "Sun"
                            ? "bg-red-100 text-red-600 hover:bg-red-200"
                            : "bg-cyan-100 text-cyan-700 hover:bg-cyan-200"
                        }`}
                        disabled={!isFunctional}
                      >
                        {day}
                      </button>
                    </td>
                    <td>
                      <input
                        type='checkbox'
                        className={`cursor-pointer rounded ${day === "Sun" ? "text-red-600" : "text-cyan-600"}`}
                        checked={timings[day].is24Hrs}
                        onChange={(e) =>
                          handleTimingChange(day, "is24Hrs", e.target.checked)
                        }
                        disabled={!isFunctional}
                      />
                    </td>
                    <td>
                      <input
                        type='time'
                        className='rounded border px-1 py-0.5 text-sm'
                        value={timings[day].shift1From}
                        onChange={(e) =>
                          handleTimingChange(day, "shift1From", e.target.value)
                        }
                        disabled={timings[day].is24Hrs || !isFunctional}
                      />
                    </td>
                    <td>
                      <input
                        type='time'
                        className='rounded border px-1 py-0.5 text-sm'
                        value={timings[day].shift1To}
                        onChange={(e) =>
                          handleTimingChange(day, "shift1To", e.target.value)
                        }
                        disabled={timings[day].is24Hrs || !isFunctional}
                      />
                    </td>
                    <td>
                      <input
                        type='time'
                        className='rounded border px-1 py-0.5 text-sm'
                        value={timings[day].shift2From}
                        onChange={(e) =>
                          handleTimingChange(day, "shift2From", e.target.value)
                        }
                        disabled={timings[day].is24Hrs || !isFunctional}
                      />
                    </td>
                    <td>
                      <input
                        type='time'
                        className='rounded border px-1 py-0.5 text-sm'
                        value={timings[day].shift2To}
                        onChange={(e) =>
                          handleTimingChange(day, "shift2To", e.target.value)
                        }
                        disabled={timings[day].is24Hrs || !isFunctional}
                      />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        <div className='mb-6'>
          <label className='mb-1 block font-medium'>
            ABDM Compliant Software
          </label>
          {abdmSoftware.map((software, idx) => (
            <div key={idx} className='mb-2 flex gap-2'>
              <input
                type='text'
                className='w-full rounded border border-gray-300 px-3 py-2 text-sm'
                value={software}
                onChange={(e) => handleAbdmSoftwareChange(idx, e.target.value)}
              />
            </div>
          ))}
          <button
            type='button'
            className='rounded bg-blue-600 px-3 py-1 text-white'
            onClick={addAbdmSoftware}
          >
            + Add Software
          </button>
          <div className='mt-4'>
            <label className='mb-1 block font-medium'>Any Other Software</label>
            <input
              type='text'
              className='w-full rounded border border-gray-300 px-3 py-2 text-sm'
              value={abdmOther}
              onChange={(e) => setAbdmOther(e.target.value)}
            />
          </div>
        </div>

        <div className='mb-6'>
          <label className='mb-1 block font-medium'>About Facility</label>
          <textarea
            rows={4}
            className='w-full rounded border border-gray-300 px-3 py-2 text-sm'
            value={facilityInformation.aboutUs}
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                facilityInformation: {
                  ...prev.facilityInformation,
                  aboutUs: e.target.value,
                },
              }))
            }
          />
        </div>

        <div className='mb-6'>
          <label className='mb-1 block font-medium'>
            Upload Building Photo
          </label>
          <input
            type='file'
            accept='image/*'
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                facilityInformation: {
                  ...prev.facilityInformation,
                  facilityUploads: {
                    ...prev.facilityInformation?.facilityUploads,
                    facilityBuildingPhoto: {
                      name: e.target.files[0]?.name || "",
                      value: "",
                    },
                  },
                },
              }))
            }
          />
        </div>

        <div className='mb-6'>
          <label className='mb-1 block font-medium'>Upload Board Photo</label>
          <input
            type='file'
            accept='image/*'
            onChange={(e) =>
              setFormData((prev) => ({
                ...prev,
                facilityInformation: {
                  ...prev.facilityInformation,
                  facilityUploads: {
                    ...prev.facilityInformation?.facilityUploads,
                    facilityBoardPhoto: {
                      name: e.target.files[0]?.name || "",
                      value: "",
                    },
                  },
                },
              }))
            }
          />
        </div>

        <div className='mb-6'>
          <label className='mb-1 block font-medium'>Address Proof</label>
          <div className='flex gap-4'>
            <div className='flex-1'>
              <label className='mb-1 block'>Type of Address Proof</label>
              <select
                className='w-full rounded border border-gray-300 px-3 py-2 text-sm'
                value={
                  facilityInformation.facilityAddressProof[0]
                    ?.addressProofType || ""
                }
                onChange={(e) =>
                  setFormData((prev) => {
                    const newProofs = [
                      ...(prev.facilityInformation?.facilityAddressProof || []),
                    ];
                    if (newProofs[0]) {
                      newProofs[0] = {
                        ...newProofs[0],
                        addressProofType: e.target.value,
                      };
                    }
                    return {
                      ...prev,
                      facilityInformation: {
                        ...prev.facilityInformation,
                        facilityAddressProof: newProofs,
                      },
                    };
                  })
                }
              >
                <option value=''>Select</option>
                <option value='Aadhaar Card'>Aadhaar Card</option>
                <option value='Voter Card'>Voter Card</option>
                <option value='Passport'>Passport</option>
              </select>
            </div>
            <div className='flex items-end justify-end gap-2'>
              <button
                type='button'
                className='rounded bg-blue-600 px-3 py-1 text-white'
                onClick={addAddressProof}
                disabled={
                  (facilityInformation.facilityAddressProof || []).length >= 3
                }
              >
                + Add Address Proof
              </button>
            </div>
          </div>

          {(facilityInformation.facilityAddressProof || []).map(
            (proof, idx) => (
              <div key={idx} className='mt-2'>
                <input
                  type='file'
                  accept='.jpg,.jpeg,.pdf,application/pdf,image/jpeg'
                  onChange={(e) => updateAddressProof(idx, e.target.files[0])}
                />
              </div>
            )
          )}
        </div>

        <div className='flex justify-end gap-4'>
          <button
            className='mb-4 rounded bg-gray-200 px-4 py-2 hover:bg-gray-300'
            onClick={() => setStep(1)}
          >
            Back
          </button>
          <button
            className='mb-4 rounded bg-[#009FE3] px-6 py-2 text-white hover:bg-blue-700'
            onClick={handleSaveDraft}
          >
            Save Draft
          </button>
        </div>
      </Layout>
    </div>
  );
};

DetailedFacility.propTypes = {
  setStep: PropTypes.func.isRequired,
  formData: PropTypes.object,
  setFormData: PropTypes.func.isRequired,
};

DetailedFacility.defaultProps = {
  formData: {},
};

export default DetailedFacility;
